import { ContentFilesView } from './content-files-view';
import { ContentVoiceTalents } from '../../../shared/api-models/content';

export class ContentFilesViewVideo extends ContentFilesView {
    showActionsBox: boolean;
    thumbnailUrl: string;
    thumbIcon: string;
    VoiceTalent: ContentVoiceTalents;
    contentType: string;
}